import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

/** Fade + rise into view. */
export function Reveal({ children, delay = 0, y = 40, once = true, className = "", style, amount = 0.25, as = "div" }) {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      style={style}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration: 1.1, ease: EASE, delay }}
    >
      {children}
    </M>
  );
}

/**
 * Line-by-line masked text reveal. Pass an array of lines (strings or nodes).
 */
export function Lines({ lines, as: Tag = "h2", className = "", delay = 0, stagger = 0.09, once = true }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once, amount: 0.3 });
  return (
    <Tag className={className} ref={ref}>
      {lines.map((line, i) => (
        <span className="line-mask" key={i}>
          <motion.span
            initial={{ y: "110%", rotate: 2 }}
            animate={inView ? { y: 0, rotate: 0 } : { y: "110%", rotate: 2 }}
            transition={{ duration: 1.2, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

/** Hairline that draws itself in. */
export function DrawRule({ className = "rule-solid", delay = 0 }) {
  return (
    <motion.hr
      className={className}
      style={{ transformOrigin: "left" }}
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true, amount: 1 }}
      transition={{ duration: 1.4, ease: EASE, delay }}
    />
  );
}
